import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useQueryPayerEngagement } from "../../../query/payerEngagements/queries/useQueryPayerEngagement";
import { useQueryPayerEngagementsList } from "../../../query/payerEngagements/queries/useQueryPayerEngagementsList";
import { useQueryPayer } from "../../../query/payers/queries/useQueryPayer";
import { WSQueries } from "../../../query/WSQuery";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { selectorPayerPayeeEngagementName } from "../../Payees/selectors/selectorPayerPayeeEngagementName";
import { usePayerEngagementHistoryResources } from "../hooks/usePayerEngagementHistoryResources";
import { getPayerEngagementUrl, PAYERS_PATH } from "../paths";

export const RoutePayerEngagementHistory: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{ engagementId: string; payerId: string }>();
  const payerId = match.params.payerId;
  const engagementId = match.params.engagementId;

  const queryEngagement = useQueryPayerEngagement(payerId, engagementId);
  const queryPayer = useQueryPayer(payerId);
  const queryPayerEngagements = useQueryPayerEngagementsList(payerId);

  const historyResources = usePayerEngagementHistoryResources(engagementId);

  return (
    <WSPage>
      <WSQueries
        queries={{ queryEngagement, queryPayer, queryPayerEngagements }}
      >
        {({ queryEngagementData, queryPayerData }) => {
          const engagementName = selectorPayerPayeeEngagementName(
            queryEngagementData,
            true
          );

          const names = wsName({
            user: {
              email: queryPayerData.user?.email as string,
              profile: queryPayerData.user?.profile
            },
            member: queryPayerData.member
          });

          return (
            <>
              <WSPageToolbar
                title="Engagement history"
                breadcrumbs={[
                  {
                    label: "Clients",
                    onClick: () => {
                      history.push(PAYERS_PATH);
                    }
                  },
                  {
                    label: names.getResolvedName(),
                    onClick: () => {
                      history.push(PAYERS_PATH + `/${payerId}`);
                    }
                  },
                  {
                    label: engagementName || "Engagement",
                    onClick: () => {
                      history.push(
                        getPayerEngagementUrl(payerId, engagementId)
                      );
                    }
                  },
                  {
                    label: "Engagement history"
                  }
                ]}
              />

              <WSGrid>
                <WSGrid.Item span={{ l: "8" }}>
                  <WSList gap="2XL">
                    <ResourceHistory resources={historyResources} />
                  </WSList>
                </WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
